__turbopack_context__.v({
  "component": "index-module__tTFyoq__component",
  "component__content": "index-module__tTFyoq__component__content",
  "component__contentWrapper": "index-module__tTFyoq__component__contentWrapper",
  "component__extraInfo": "index-module__tTFyoq__component__extraInfo",
  "component__icon": "index-module__tTFyoq__component__icon",
  "component__icon__dark": "index-module__tTFyoq__component__icon__dark",
  "component__list": "index-module__tTFyoq__component__list",
  "component__productLockup": "index-module__tTFyoq__component__productLockup",
  "component__productPrice": "index-module__tTFyoq__component__productPrice",
  "component__productPricingLegal": "index-module__tTFyoq__component__productPricingLegal",
  "component__product_priceStrike": "index-module__tTFyoq__component__product_priceStrike",
  "component__shortLegal": "index-module__tTFyoq__component__shortLegal",
  "component__subtitle": "index-module__tTFyoq__component__subtitle",
  "component__title": "index-module__tTFyoq__component__title",
  "hide-for-large": "index-module__tTFyoq__hide-for-large",
  "hide-for-large-only": "index-module__tTFyoq__hide-for-large-only",
  "hide-for-medium": "index-module__tTFyoq__hide-for-medium",
  "hide-for-medium-only": "index-module__tTFyoq__hide-for-medium-only",
  "hide-for-small-only": "index-module__tTFyoq__hide-for-small-only",
  "show-for-large": "index-module__tTFyoq__show-for-large",
  "show-for-large-only": "index-module__tTFyoq__show-for-large-only",
  "show-for-medium": "index-module__tTFyoq__show-for-medium",
  "show-for-medium-only": "index-module__tTFyoq__show-for-medium-only",
  "show-for-small-only": "index-module__tTFyoq__show-for-small-only",
  "u-color-black": "index-module__tTFyoq__u-color-black",
  "u-color-blue": "index-module__tTFyoq__u-color-blue",
  "u-color-midnight": "index-module__tTFyoq__u-color-midnight",
  "u-color-primary-dark": "index-module__tTFyoq__u-color-primary-dark",
  "u-color-red": "index-module__tTFyoq__u-color-red",
  "u-color-white": "index-module__tTFyoq__u-color-white",
  "u-theme-black": "index-module__tTFyoq__u-theme-black",
  "u-theme-blue": "index-module__tTFyoq__u-theme-blue",
  "u-theme-dark": "index-module__tTFyoq__u-theme-dark",
  "u-theme-light": "index-module__tTFyoq__u-theme-light",
  "u-theme-red": "index-module__tTFyoq__u-theme-red",
  "u-theme-white": "index-module__tTFyoq__u-theme-white",
});
